import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-v_dark_blue" }
const _hoisted_2 = { class: "text-[2rem] font-[700] text-center" }

import {
	NotificationContainer,
	H2,
	ModalButton,
	ModalContainer,
} from "../atoms"

import { Notification } from "@/utils/enum"
import router from "@/router"
import { removeItems } from "@/utils/permissions"


export default /*#__PURE__*/_defineComponent({
  __name: 'Notifications',
  props: {
	title: { type: String, required: true },
	subtitle: { type: String, required: true },
},
  emits: ["closeNotification"],
  setup(__props, { emit }) {

const props = __props;





const closeNotificationModal = () => {
	if (props.title == Notification.TITLE_SESSION_EXPIRED) {
		emit("closeNotification", false)
		router.push("/")
		removeItems()
	} else {
		emit("closeNotification", false)
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(NotificationContainer), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.title), 1),
            _createVNode(_unref(H2), { class: "text-black opacity-[50%]" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.subtitle), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(ModalButton), {
            "enable-button": true,
            class: "active:scale-90",
            w: "14rem",
            h: "3.60rem",
            onClick: closeNotificationModal
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Confirmar ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})